/**
 * Bildmarke von MeinRegalladen: drei Regalböden in Violett, ein Artikel in Limette – ohne umrahmendes Quadrat.
 * Ersetzt das frühere Initialen-Monogramm überall (Verwaltung, Kasse, Mieterportal, Anmeldung). Ein Laden-Logo ersetzt nur die Bildmarke.
 */
export function Marke({ size = 40, className }: { size?: number; className?: string }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 40 40" aria-hidden="true" focusable="false" style={{ flex: "none" }}>
      <g stroke="var(--accent)" strokeWidth="3.5" strokeLinecap="round" fill="none">
        <path d="M5 10.5h30" />
        <path d="M5 21h30" />
        <path d="M5 31.5h30" />
      </g>
      <rect x="22" y="12.5" width="9" height="7" rx="1.5" fill="var(--limette)" />
      <rect x="9" y="23" width="7" height="7" rx="1.5" fill="var(--limette)" />
    </svg>
  );
}
